import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {

  @Input() loading = false;
  @Input() message = 'Guardando...';
  @Input() progressPercentage = 0;
  @Input() loadingDocuments = false;

}
